// extracted by mini-css-extract-plugin
export default {"App_container":"App_App_container__SY46N"};